// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__3r5Bj","card":"Wrapper_card__3psRP","loaderBlock":"Wrapper_loaderBlock__2F3Ow","noData":"Wrapper_noData__3_U7e","sourceList":"Wrapper_sourceList__2YPUC"};